import { Link } from 'react-router-dom';
import { ROUTES } from '@constants/routes';

/** A cylinder's serial number linking to its page. */
export function CylinderLink({ id, serial, className = 'mono' }: { id: number; serial: string | null; className?: string }) {
  return (
    <Link to={ROUTES.cylinder(id)} className={className}>
      {serial}
    </Link>
  );
}
